export default __webpack_public_path__ + "static/media/AUDI.bdc75541.png";